
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Viele Betroffene wissen nicht, dass es einen
Medikamenten-Übergebrauch-Kopfschmerz gibt. Weil sie nicht merken, dass ihr
Kopfschmerz durchs Schmerzmittel verursacht wird, nehmen sie immer weiter und
öfter Schmerzmittel – und verschlimmern dadurch ihre Kopfschmerzen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;